// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import ConvoyMenu from './ConvoyMenu'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectAu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0,

        };


    }

    componentDidMount() {



    }


    onToggleTab = (value) => {
        this.setState({ currentTab: value })
    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu={'9'} />
                <div className='dv_project_body'>
                    <ConvoyMenu activeMenu={8} />
                    <div className='dv_project_body_right'>
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'>
                                <img src={require("./assets/img/convoy/55_000050.jpg")} />
                                <img src={require("./assets/img/convoy/55_000051.jpg")} />
                            </div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_trake_change flex-row between'>
                                    <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>中北非国际教育创新联盟</div>
                                    <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>中欧全球南方文化教育联盟</div>
                                </div>
                                {this.state.currentTab == 0 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000052.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />
                                    </div>
                                </div>}
                                {this.state.currentTab == 1 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000053.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000054.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />
                                    </div>
                                </div>}

                            </div>
                        </div>
                    </div>
                </div>


                <Footer />
            </div >

        );
    }
}

export default withRouter(ProjectAu);